import Component from './YearPicker';
export default Component;

export const componentName = 'YearPicker';
